import DefaultBlock from "/scripts/default/block";

export default class PricingFaqs extends DefaultBlock {
	init() {}
}
